// extracted by mini-css-extract-plugin
export default {"errorMsg":"workspace-selector_errorMsg__2fm0V","addButton":"workspace-selector_addButton__FN9Te"};